import ADC from '@appblocks/codegeneration/Peripherals/ADC';
import BasePeripheral from '@appblocks/codegeneration/Peripherals/_BasePeripheral';
import GPIO from '@appblocks/codegeneration/Peripherals/GPIO';
import I2C from '@appblocks/codegeneration/Peripherals/I2C';
import Interrupt from '@appblocks/codegeneration/Peripherals/Interrupt';
import IOPort from '@appblocks/codegeneration/Peripherals/IOPort';
import Ser from '@appblocks/codegeneration/Peripherals/Ser';
import Ser232 from '@appblocks/codegeneration/Peripherals/Ser232';
import Ser422 from '@appblocks/codegeneration/Peripherals/Ser422';
import Ser485 from '@appblocks/codegeneration/Peripherals/Ser485';
import SPI from '@appblocks/codegeneration/Peripherals/SPI';
import PWM from '@appblocks/codegeneration/Peripherals/PWM';
import DHT22 from '@appblocks/codegeneration/Peripherals/DHT22';
import { PinConfig } from '@appblocks/codegeneration/types';
import { DEVICE_PINS } from '@appblocks/platforms/PlatformUtils';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import SSD1306 from '@appblocks/codegeneration/Peripherals/SSD1306';
import ST7789 from '@appblocks/codegeneration/Peripherals/ST7789';
import Button from '@appblocks/codegeneration/Peripherals/Button';
import DHT11 from '@appblocks/codegeneration/Peripherals/DHT11';
import MCP9808 from '@appblocks/codegeneration/Peripherals/MCP9808';
import LED from '@appblocks/codegeneration/Peripherals/LED';
import SHTC3 from '@appblocks/codegeneration/Peripherals/SHTC3';
import Ili9342c from '@appblocks/codegeneration/Peripherals/Ili9342c';
import Ili9341 from '@appblocks/codegeneration/Peripherals/Ili9341';
import Servo from '@appblocks/codegeneration/Peripherals/Servo';
import UART from '@appblocks/codegeneration/Peripherals/UART';
import ReferencedPin from './ReferencedPin';


const PeripheralsMap: { [peripheralId: string]: typeof BasePeripheral } = {
    adc: ADC,
    gpio: GPIO,
    i2c: I2C,
    int: Interrupt,
    ioport: IOPort,
    ser: Ser,
    ser232: Ser232,
    ser422: Ser422,
    ser485: Ser485,
    spi: SPI,
    pwm: PWM,
    dht22: DHT22,
    ssd1306: SSD1306,
    st7789: ST7789,
    dht11: DHT11,
    mcp9808: MCP9808,
    button: Button,
    led: LED,
    shtc3: SHTC3,
    ili9342c: Ili9342c,
    // referenced_pin: ReferencedPin,
    ili9341: Ili9341,
    servo: Servo,
    serial: UART,
};

export default class Peripherals {
    static getItem(itemId: string, project: ProjectConfiguration) {
        if (PeripheralsMap[itemId] !== undefined) {
            return new PeripheralsMap[itemId]();
        }

        return undefined;
    }

    static getList() {
        return Object.keys(PeripheralsMap);
    }

    static getPinConstant(pinId: string, platformId: string): string {
        const pinList = DEVICE_PINS[platformId];

        for (let i = 0; i < pinList.length; i += 1) {
            if (pinList[i].num === pinId) {
                return pinList[i].constant || '';
            }
        }
        return '';
    }

    static getPin(pinId: string, platformId: string): PinConfig | undefined {
        const pinList = DEVICE_PINS[platformId];

        for (let i = 0; i < pinList.length; i += 1) {
            if (pinList[i].num === pinId) {
                return pinList[i];
            }
        }
        return undefined;
    }

    static getGPIOPeripheral(pinId: string, platformId: string): any | undefined {
        const pinConfig = this.getPin(pinId, platformId);
        if (pinConfig === undefined) {
            return undefined;
        }
        if (pinConfig.peripherals.length === 0) {
            return undefined;
        }
        const gpio = pinConfig.peripherals.find(p => p.peripheralType === 'gpio');
        return gpio;
    }

    static getGPIOPin(pinId: string, platformId: string): string {
        const pinConfig = this.getPin(pinId, platformId);
        if (pinConfig === undefined) {
            return '';
        }
        if (pinConfig.peripherals.length === 0) {
            return '';
        }
        const gpio = pinConfig.peripherals.find(p => p.peripheralType === 'gpio');
        return gpio ? gpio.peripheralPort : '';
    }

    static getInterrupt(pinId: string, platformId: string): string {
        const pinList = DEVICE_PINS[platformId];

        for (let i = 0; i < pinList.length; i += 1) {
            if (pinList[i].num === pinId) {
                for (let j = 0; j < pinList[i].peripherals.length; j++) {
                    if (pinList[i].peripherals[j].peripheralType === 'int') {
                        return pinList[i].peripherals[j].peripheralPort;
                    }
                }
            }
        }
        return '';
    }
}
